import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BlockList = _resolveComponent("BlockList")!
  const _component_HeroBanner = _resolveComponent("HeroBanner")!

  return (_openBlock(), _createBlock(_component_HeroBanner, {
    "vimeo-id": _ctx.vimeoId,
    image: _ctx.image,
    autoplay: _ctx.content.autoPlay
  }, {
    default: _withCtx(() => [
      _createVNode(_component_BlockList, {
        blocks: _ctx.content.tiles,
        nested: true,
        class: _normalizeClass(["c-hero-banner__content", {'c-hero-banner__content-shadows-enabled': _ctx.content.isScrimEnabled }])
      }, null, 8, ["blocks", "class"])
    ]),
    _: 1
  }, 8, ["vimeo-id", "image", "autoplay"]))
}